import { LOCAL_STORAGE_DATA } from './../../utils/variables'

const useFetchAdminData = () => {
    const data = localStorage.getItem(LOCAL_STORAGE_DATA)
    return data ? JSON.parse(data) : {}
}

export default useFetchAdminData